import { render, staticRenderFns } from "./DictEntryActions.vue?vue&type=template&id=833a1ed6&"
import script from "./DictEntryActions.vue?vue&type=script&lang=js&"
export * from "./DictEntryActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports